// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1fm2e","content":"LayoutSettings_content__3QURl"};